export default "__VITE_ASSET__D1d0AAw9__"